import styled from "styled-components";

export const Noti = styled.div`
	position: fixed;
	width: fit-content;
	min-height: 30px;
	right: 50%;
	transform: translatex(50%);
	text-align: center;
	border-radius: 5px;
	box-shadow: rgb(0 0 0 / 45%) 1px 1px 20px;
	border: 1px solid #c3c3c3;
	z-index: 9999999;
	animation: slideIn 0.3s ease forwards;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	padding: 0 20px;
	background: #ffffff;
	svg {
		width: 20px;
		height: 20px;
	}
`;
